import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LearningTestItem from '../LearningTestItem';
import './styles.scss';
import { getUserMicroLearningAnswers } from '../../../../actionCreators/userProfile';
import { logFirebaseEvent } from '../../../../firebase/analytics';

import ProgressBar from '../../../../components/global/ProgressBar';
import { useNavigate } from 'react-router-dom';

const LearningResultsComponent = ({
  progressBarLength,
  results,
  id,
  handleResults,
  score,
  questions,
  taskId,
  firstTimeLogin,
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    handleResults({ answers: Object.values(results), id: id });
  }, [handleResults, id, results]);

  const handleLength = () => {
    const answersLength = questions.filter((question) => question.answers !== null) || 0;
    return answersLength;
  };

  return (
    <React.Fragment>
      <div className="progressbar">
        <ProgressBar className="m-0" width={progressBarLength} />
      </div>
      <div className="results-container-scroll">
        <div>
          <div className="results-container">
            <h2 className="title">Your results:</h2>
            {questions && handleLength().length < 1 ? (
              <p className="subtitle"> Congratulations! You completed this microlearning.</p>
            ) : (
              <p className="subtitle">
                You got
                <strong>
                  {' '}
                  {score} out <span className="me-1">of</span>
                  {questions && handleLength().length}
                </strong>
                <span className="ms-1">questions</span> correct. Your selections are in
                <strong> bold.</strong>
              </p>
            )}
            {questions && questions.length > 1 && (
              <LearningTestItem length={handleLength} questions={questions} />
            )}
          </div>
          <div className="results-bottom-container text-right">
            <button
              onClick={() => {
                navigate(
                  taskId
                    ? `/employee_onboarding?firstTimeLogin=${firstTimeLogin}`
                    : '/engage?tab=learning',
                );
                {
                  taskId
                    ? logFirebaseEvent({
                        event: 'employee_onboarding',
                        action: 'task_completed',
                      }) &&
                      logFirebaseEvent({
                        event: 'learning',
                        action: 'completed',
                      })
                    : logFirebaseEvent({
                        event: 'learning',
                        action: 'completed',
                      });
                }
              }}
              className="text-uppercase finish-btn"
            >
              finish
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const LearningResults = (props) => {
  const state = useSelector((state) => ({
    score: state.currentUser.learningResults.score,
    questions: state.currentUser.learningResults.questions,
  }));

  const dispatch = useDispatch();

  const actions = {
    handleResults: (payload) => dispatch(getUserMicroLearningAnswers(payload)),
  };

  return <LearningResultsComponent {...props} {...state} {...actions} />;
};

export default LearningResults;
